const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const clean = (value) => {
  const normalized = String(value ?? "").trim();
  return normalized || null;
};

const isPublicIdentifier = (value) =>
  Boolean(value && !UUID_PATTERN.test(value));

export const resolvePatientPublicIdentifier = (
  profileData,
  patientData
) => {
  const explicitIdentifier = [
    profileData?.identifier,
    profileData?.patientIdentifier,
    patientData?.identifier,
    patientData?.patientIdentifier,
  ]
    .map(clean)
    .find(isPublicIdentifier);

  if (explicitIdentifier) {
    return explicitIdentifier;
  }

  return (
    [profileData?.patientId, patientData?.patientId]
      .map(clean)
      .find((value) => /^PTN-/i.test(value ?? "")) ?? null
  );
};
